const types = {
  FETCH_MY_MATCHES_SENDERS_START: 'FETCH_MY_MATCHES_SENDERS_START',
  FETCH_MY_MATCHES_SENDERS_SUCCESS: 'FETCH_MY_MATCHES_SENDERS_SUCCESS',
  FETCH_MY_MATCHES_SENDERS_FAILURE: 'FETCH_MY_MATCHES_SENDERS_FAILURE',
}

export default types
